









































































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";

import { API_URL } from "../global";
import {
  pageDataType,
  sociallinkItem,
  settinglinkItem,
  RmainMenuItem,
} from "../types";
import {
  FETCH_RMAIN_MENU,
  FETCH_SOCIAL,
  FETCH_SETTING,
} from "../store/actions.names";
import { pageData } from "../store/pageData";
import axios from "axios";
import {
  TweenMax,
  TimelineLite,
  Power3,
  Power4,
  Power2,
  TimelineMax,
} from "gsap";
import AOS from "aos";

@Component({
  name: "Footer",
})
export default class Footer extends Vue {
  @Getter("rmainMenu") public rmainMenu!: RmainMenuItem[];
  @Getter("sociallink") public sociallink!: sociallinkItem[];
  @Getter("settinglink") public settinglink!: settinglinkItem[];
  @Getter("pageData") public pageData!: pageDataType;
  @Getter("pageType") public pageType!: string | null;
  @Action(FETCH_RMAIN_MENU) public [FETCH_RMAIN_MENU]: any;
  @Action(FETCH_SOCIAL) public [FETCH_SOCIAL]: any;
  @Action(FETCH_SETTING) public [FETCH_SETTING]: any;

  // created() {
  //     AOS.init();
  // }
  // handleScroll(event: any) {
  //     if (window.pageYOffset > 1600) {
  //         AOS.refreshHard();
  //         AOS.init();
  //         AOS.refresh();
  //         console.log("triggered");
  //     }
  //     console.log(window.pageYOffset);
  // }

  created() {
    window.addEventListener("scroll", this.scrolling);
  }
  destroyed() {
    window.removeEventListener("scroll", this.scrolling);
  }
  scrolling() {
    let scrollpos = window.scrollY;
    let d: any = document;
    const elem = d.querySelector(".footer-container");
    const header_height = elem.offsetHeight;
    const add_class_on_scroll = () => elem.classList.add("fade-in");
    const remove_class_on_scroll = () => elem.classList.remove("fade-in");
    window.addEventListener("scroll", function() {
      scrollpos = window.scrollY;
      if (scrollpos >= header_height) {
        add_class_on_scroll();
        // console.log('scrolltrigger');
      } else {
        remove_class_on_scroll();
      }
      // console.log(scrollpos)
    });
  }
  mounted() {
    // this.scrolling();
    this[FETCH_SOCIAL]();
    this[FETCH_SETTING]();
  }
}
